<div class="content content-with-elevation">
<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" novalidate>
    <common-alerts [errorMessage]="errorMessage"></common-alerts>
    <common-alerts [error]="error"></common-alerts>

    <div class="grid-x form-group">

      <div class="cell large-6 medium-6 small-12">
        <label>New Password
          <input formControlName="newPassword" type="password"
                 class="input-group-custom" required>
          <div style="width: 90%">
            <password-strength-meter [password]="resetPasswordForm.controls.newPassword.value"
                                     [minPasswordLength]="8"></password-strength-meter>
          </div>
        </label>

        <label>Confirm new password
          <input formControlName="verifyNewPassword" type="password"
                 class="input-group-custom" required>
        </label>

      </div>

      <div class="cell large-6 medium-6 small-12" style="display: flex;align-items: center; padding: 1rem; border-left: 1px solid gray">
        <div class="grid-y">
          <div class="requirements-group">
            <fa-icon [icon]="(resetPasswordForm.controls.newPassword.errors && resetPasswordForm.controls.newPassword.errors.minimumLength)
                ? 'times-circle': 'check'"></fa-icon><span class="requirements"> Minimum 8 characters in length</span>
          </div>
          <div>
            <fa-icon [icon]="(resetPasswordForm.controls.newPassword.errors && resetPasswordForm.controls.newPassword.errors.spaces)
                ? 'times-circle': 'check'"></fa-icon> No leading or trailing white spaces
          </div>
          <div class="requirements-group">
            <fa-icon [icon]="(resetPasswordForm.controls.newPassword.errors && resetPasswordForm.controls.newPassword.errors.numbers)
                ? 'times-circle': 'check'"></fa-icon><span class="requirements"> Include numeric characters (0-9)</span>

          </div>
          <div class="requirements-group">
            <fa-icon [icon]="(resetPasswordForm.controls.newPassword.errors && resetPasswordForm.controls.newPassword.errors.upperCase)
                ? 'times-circle': 'check'"></fa-icon><span class="requirements">  Include uppercase (A-Z)</span>
          </div>
          <div class="requirements-group">
            <fa-icon [icon]="(resetPasswordForm.controls.newPassword.errors && resetPasswordForm.controls.newPassword.errors.lowerCase)
                ? 'times-circle': 'check'"></fa-icon><span class="requirements"> Include lowercase (a-z)</span>
          </div>
          <div class="requirements-group">
            <fa-icon [icon]="(resetPasswordForm.controls.newPassword.errors && resetPasswordForm.controls.newPassword.errors.specialCharacters)
                ? 'times-circle': 'check'"></fa-icon><span class="requirements"> Include special characters such as &#64;, #, !, &, ^,*, ~, (, )</span>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-x">
      <div class="finalize-request">
        <fa-icon [icon]="'exclamation-triangle'" class="iana-icons align-center"></fa-icon>
        <div style="padding-left: 16px;">
            <p style="margin-bottom: 0;">
            Establishing an account and creating a password by clicking "Submit", you acknowledge that your personal
            data will be processed in accordance with our <a style="white-space: nowrap" href="https://www.icann.org/privacy" target="_blank">Privacy Policy</a>
            and agree to abide by the website <a style="white-space: nowrap" href="https://www.icann.org/privacy/tos" target="_blank">Terms of Service</a>.
            </p>
        </div>
      </div>

    </div>
    <div class="grid-x">
      <div class="cell medium-4 large-2 small-12"></div>

      <div class="cell medium-8 large-10 small-12">
        <div class="save-cancel-button-group">
          <button class="iana-button"  type="submit"
                  [disabled]="!resetPasswordForm.valid">Submit
          </button>
          <button class="iana-button-cancel" type="reset" (click)="cancel()">Cancel</button>
        </div>
      </div>
    </div>
  </form>
</div>
